import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DateTimePipe, FileSizePipe } from '@nimmsta/ng-commons-lib/pipes';
import {
  Software,
  SoftwareArtifact,
  SoftwareArtifactStatus,
} from '@nimmsta/ng-commons-lib/models';
import { TranslatePipe } from '@ngx-translate/core';
import { SoftwareArtifactDownloadButtonComponent } from '../software-artifact-download-button.component';
import { MarkdownComponent } from 'ngx-markdown';

@Component({
  selector: 'app-software-detail-header',
  templateUrl: './software-detail-header.component.html',
  styleUrls: [
    'software-detail-header.component.scss',
    '../software-label.scss',
  ],
  imports: [
    TranslatePipe,
    SoftwareArtifactDownloadButtonComponent,
    MarkdownComponent,
    TranslatePipe,
    FileSizePipe,
    DateTimePipe,
  ],
})
export class SoftwareDetailHeaderComponent {
  @Input() software!: Software;

  @Input() artifact!: SoftwareArtifact;

  @Input() isAdmin = false;

  @Output() scrollToVersions = new EventEmitter<void>();

  SoftwareArtifactStatus = SoftwareArtifactStatus;
}
